import { EditorContent } from '@tiptap/react';
import { useEffect } from 'react';
import { useEditor } from './useEditor.ts';

export function Editable({ autoFocus }: { autoFocus?: boolean }) {
  const editor = useEditor();

  useEffect(() => {
    if (autoFocus) {
      const timeout = setTimeout(() => editor.commands.focus(0), 0);

      return () => {
        return clearTimeout(timeout);
      };
    }
  }, [autoFocus, editor]);

  return <EditorContent editor={editor} />;
}
